import { render, staticRenderFns } from "./CustomersReport.vue?vue&type=template&id=ca278a00&scoped=true&"
import script from "./CustomersReport.vue?vue&type=script&lang=js&"
export * from "./CustomersReport.vue?vue&type=script&lang=js&"
import style0 from "./CustomersReport.vue?vue&type=style&index=0&id=ca278a00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca278a00",
  null
  
)

export default component.exports